import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config/api';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) return;

    fetch(`${API_URL}/api/page-views`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: location.pathname }),
    }).catch(() => {});
  }, [location.pathname]);
};

export default usePageTracking;
